$(() => {
    if ($(window).width() > 768) {
        $('.search-bar--mobile').hide();
    } else {
        $('.search-bar--mobile').show();
    }
    $(window).resize(function () {          //当浏览器大小变化时
        if ($(window).width() > 768) {
            $('.search-bar--mobile').hide();
        } else {
            $('.search-bar--mobile').show();
        }
    });
    var iconindex = 1;
    $('.mobile-footer-linklist-title').click(function () {
        $(this).siblings('.mobile-footer-linklist-lisk').slideToggle();
        if (iconindex == 1) {
            $(this).children('.icon').addClass('icon-minus').removeClass('icon-plus');
            iconindex = 0;
        } else {
            $(this).children('.icon').addClass('icon-plus').removeClass('icon-minus');
            iconindex = 1;
        }
    })
    Shopify.queryParams = {};
    if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
                Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
            }
        }
    }
    
    $('#sortBy-mobile').bind('click',function(){
        $(this).find('.fliter-option').slideToggle();
    })
    
    
    $('#sortBy .fliter-option-item').bind('click', function () {
        Shopify.queryParams.sort_by = $(this).attr('data-value');
        location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
    });
    $('.cart__product-qty').on('change',function(){
        $('.update-cart').trigger('click');
    })
})

